import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ToursIntro() {
  return <section id="toursexcursionsintro" data-nav="light" aria-labelledby="tours-excursions-title" className="bg-background text-foreground pt-14 pb-8 sm:pt-20 sm:pb-10 md:pt-24 md:pb-12">
      <div className="mx-auto max-w-[1136px] px-6">
        <div className="max-w-3xl">
          <h1 id="tours-excursions-title" className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl font-default">
            Tours &amp; Excursions from Hurghada
          </h1>

          <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg sm:leading-relaxed">
            Discover Red Sea islands, desert adventures, cultural day trips and local experiences with Hurghada Transfer Hub. Enjoy a private hotel transfer reserved for you and your companions, with shared or private activities depending on your chosen excursion.
          </p>

          <div className="mt-8">
            <Button asChild size="lg" className="rounded-lg font-semibold text-base px-6 py-3">
              <Link to="#day-trip-excursions">
                Explore Excursions
              </Link>
            </Button>
          </div>

          <div className="mt-6">
            <Link to="/PrivateDriverHirePage" className="inline-flex items-center gap-1.5 text-sm font-semibold text-foreground underline underline-offset-4 decoration-border transition-colors hover:text-primary hover:decoration-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              Looking for hourly private driver hire instead?
              <ArrowRight className="size-4 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}